import { put, takeEvery } from "redux-saga/effects";

import { addNotification, loading } from "layouts/AppLayout/modules";
import { getApi } from "../../../sagas";
import { DELETE_APP, DeleteAppAction, deleteAppEnd } from "../actions";

export function* deleteApp(action: DeleteAppAction) {
    const { payload } = action;
    const { appId } = payload;

    const api = getApi(payload);

    try {
        yield put(loading(true, action));
        yield api.deleteApp(appId);
        yield put(deleteAppEnd(undefined, appId));
        yield put(addNotification(`${appId} successfully deleted`));
    } catch (e) {
        yield put(deleteAppEnd(e, appId));
        yield put(addNotification(e.message, true));
    } finally {
        yield put(loading(false, action));
    }
}

export function* watchDeleteApp() {
    yield takeEvery(DELETE_APP, deleteApp);
}
